import { Illustration } from '@repo/go-ui';
import { useTranslation } from 'react-i18next';

import styles from './VideoBroadcastWidget.module.scss';

export function VideoBroadcastPlaceholder() {
  const { t } = useTranslation('videoBroadcastWidget', { useSuspense: false });

  return (
    <div className={styles.placeholder}>
      <div className={styles.placeholderImage}>
        <Illustration.EmptyWidget style={{ width: '100%', height: '100%' }} />
      </div>

      <div className={styles.noCameraText}>{t('empty.addCamera')}</div>
    </div>
  );
}
